import { EDITOR_ORIGIN } from '~/constants/editor';
import { Hint } from '~/hints/Hint';
import { Editor } from 'codemirror';

export const isEmptyEditor = (editor: Editor) => {
  return editor.lineCount() === 1 && editor.getLine(0) === '';
};

export const insertText = (editor: Editor, text: string, origin?: EDITOR_ORIGIN) => {
  return editor.getDoc().replaceSelection(text, null, origin);
};

export const goToEnd = (editor: Editor) => {
  editor.execCommand('goDocEnd');
};

export const getValue = (editor: Editor) => {
  return editor.getValue();
};

export const setValue = (editor: Editor, value: string) => {
  editor.setValue(value);
};

export const clearValue = (editor: Editor) => {
  setValue(editor, '');
};

export const getCursor = (editor: Editor) => {
  return editor.getCursor();
};

export const getBeforeChar = (editor: Editor) => {
  const position = getCursor(editor);
  const line = editor.getLine(position.line);
  return line[position.ch - 1] || '';
};

export const insertNewLine = (editor: Editor) => {
  editor.execCommand('newlineAndIndent');
};

// cursor 앞에 공백이 없으면 추가함
export const getBeforeSpace = (editor: Editor) => {
  const beforeChar = getBeforeChar(editor);
  return /^\s?$/.test(beforeChar) ? '' : ' ';
};

export const getSelection = (editor: Editor) => {
  return editor.getSelection();
};

export const getCursorAndBeforeText = (editor: Editor) => {
  const cursor = getCursor(editor);
  return { cursor, text: editor.getRange({ ...cursor, ch: 0 }, cursor) };
};

export const refreshEditor = (editor: Editor) => {
  editor?.refresh();
};

export const setCursor = (editor: Editor, pos: CodeMirror.Position) => {
  editor.setCursor(pos);
};

export const scrollIntoView = (editor: Editor, pos: CodeMirror.Position | null) => {
  editor.scrollIntoView(pos);
};

export const cursorCoords = (editor: Editor) => {
  return editor.cursorCoords() as unknown as CodeMirror.Position;
};

export const setOption = (editor: Editor, ...args: Parameters<Editor['setOption']>) => {
  return editor.setOption(...args);
};

export const replaceRange = (
  editor: Editor,
  replacement: string | string[],
  from: CodeMirror.Position,
  to?: CodeMirror.Position,
  origin?: EDITOR_ORIGIN
) => {
  return editor.replaceRange(replacement, from, to, origin);
};

export const findHint = (editor: Editor, hints: Hint[]) => {
  const cursor = getCursor(editor);
  const text = editor.getRange({ ...cursor, ch: 0 }, cursor);
  const hint = hints.find((hint) => hint.checkActive(text, cursor));
  return hint ? { hint, text } : null;
};
